module.exports = __webpack_public_path__ + "static/media/Test24.cc6b89a1.bmp";